import {
  Directive,
  EffectRef,
  Injector,
  OnDestroy,
  Signal,
  TemplateRef,
  ViewContainerRef,
  effect,
  inject
} from '@angular/core';

/**
 * @description
 * a base structural directive, it will allows the rendering of its template only if the "isMatch$$"
 * predicate is true. when the isMatch$$ IS true, content will be injected into the DOM, if false -
 * content will be removed from the DOM.
 *
 * this directive is meant to be consumed by inheritance (only) by other structural directives - all
 * of which implements the "isMatch$$" property requirement. this directive is not to be used directly
 * (note - there is no selector),
 */

@Directive({
  standalone: true
})
export abstract class TemplateAssertDirective implements OnDestroy {
  /** an abstract boolean predicate resolver - must be implemented in each inheritor of this directive */
  abstract readonly isMatch$$: Signal<boolean>;

  private _containerRef = inject(ViewContainerRef);
  private _templateRef = inject(TemplateRef);
  private _injector = inject(Injector);

  private _toggleRef: EffectRef;

  constructor() {
    this._toggleRef = effect(
      () => {
        if (!this.isMatch$$) {
          return;
        }
        /** resolve the isMatch predicate */
        const isMatch = this.isMatch$$();
        /** clear previous or existing content */
        this._containerRef.clear();
        if (isMatch) {
          /** render the new content */
          this._containerRef.createEmbeddedView(this._templateRef);
        }
      },
      { injector: this._injector, allowSignalWrites: true }
    );
  }

  ngOnDestroy(): void {
    this._toggleRef.destroy();
  }
}
